import * as z from 'zod/mini';

export const deviceSigningKeysSchema = z.object({
  privateJwk: z.custom<JsonWebKey>(),
  privateKey: z.string(),
  publicKey: z.string(),
});
